import React from 'react';
import { ROSTER_DAILY_CONFIG } from '../roster-daily-config';
import { EndSpacer } from './EndSpacer';

interface WorkersTimelineHeaderProps {
  rowWidth: number;
  markers?: React.ReactNode[];
}

export function WorkersTimelineHeader({ rowWidth, markers }: WorkersTimelineHeaderProps) {
  const { CONTENT_GROUP_HEIGHT } = ROSTER_DAILY_CONFIG;

  return (
    <div className='flex-row'>
      <div
        className='bg-tertiary width-full bordered-bottom bordered-top position-relative'
        style={{ height: CONTENT_GROUP_HEIGHT, minWidth: rowWidth, maxWidth: rowWidth }}
      >
        {markers}
      </div>
      <EndSpacer height={56} />
    </div>
  );
}
